module.exports = __webpack_public_path__ + "static/media/place.f00335ec.svg";